export const NURSE_STAFF_CREDENTIAL_TYPES = ["NAR", "NAC", "HCA"];

export type NurseStaffCredentialType = (typeof NURSE_STAFF_CREDENTIAL_TYPES)[number];

export const NURSE_STAFF_BASIC_TRAINING_ITEMS = [
  { completedKey: "basicTrainingCoreCompetencyCompleted", dateKey: "basicTrainingCoreCompetencyDate", label: "Basic Training (Core Competency) Certificate or Transcript of Completion" },
  { completedKey: "basicTraining75HoursCompleted", dateKey: "basicTraining75HoursDate", label: "75 Hours of DSHS Approved HCA Basic Training certificate or transcript" },
  { completedKey: "fundamentalsOfCareCompleted", dateKey: "fundamentalsOfCareDate", label: "Fundamentals of Care (FOC)" },
  { completedKey: "revisedFundamentalsOfCareCompleted", dateKey: "revisedFundamentalsOfCareDate", label: "Revised Fundamentals of Care (RFOC)" },
  { completedKey: "dda32HourLetterCompleted", dateKey: "dda32HourLetterDate", label: "DDA 32 Hour Letter" },
] as const;
